/**
 * Regex Pattern Recognition for Query Parser
 */

"use strict";

import { debugMode } from './constants.js';

/**
 * Helper: Check if a string looks like a regex pattern
 * @param {string} str - String to check
 * @returns {boolean}
 */
export function isRegexPattern(str) {
    if (!str || typeof str !== 'string') return false;
    const trimmed = str.trim();
    
    // Check for /pattern/ or /pattern/flags format
    if (/^\/[^\/]+\/[gimsu]*$/.test(trimmed)) {
        return true;
    }
    
    // Check for r[flags]"pattern" or r[flags]'pattern' format (Python-style with optional flags)
    if (/^r[gimsu]*["']/.test(trimmed)) {
        return true;
    }
    
    // Check if starts with regex metacharacters: \d, \w, \s, \b, etc.
    if (/^\\[dwsbDSWBAZzG]/.test(trimmed)) {
        return true;
    }
    
    // Check if contains regex constructs: (?:, (?=, (?!, \d+, \w+, etc.
    if (/\(\?[:=!]|\\[dwsbDSWBAZzG]\+|\\[dwsbDSWBAZzG]\{|\[.*\]|\^|\$/.test(trimmed)) {
        return true;
    }
    
    return false;
}

/**
 * Helper: Extract regex pattern from /pattern/flags or r"pattern"
 * @param {string} str - Input string
 * @returns {object} { pattern, flags }
 */
export function extractRegexPattern(str) {
    const trimmed = str.trim();
    
    // /pattern/flags format
    const slashMatch = trimmed.match(/^\/([^\/]+)\/([gimsu]*)$/);
    if (slashMatch) {
        return { pattern: slashMatch[1], flags: slashMatch[2] || 'i' };
    }
    
    // r[flags]"pattern" or r[flags]'pattern' format
    const rMatch = trimmed.match(/^r([gimsu]*)(["'])(.+)\2$/);
    if (rMatch) {
        // Default to no flags (case-sensitive) if not provided
        // Unicode flag 'u' will be added automatically in file-matcher.js
        return { pattern: rMatch[3], flags: rMatch[1] || '' };
    }
    
    // Plain regex pattern (starts with \d, \w, etc.)
    return { pattern: trimmed, flags: 'i' };
}
